import { TertiaryButton } from '@rsa-digital/evo-shared-components/components/Button';
import Icon from '@rsa-digital/evo-shared-components/components/Icon';
import colors from '@rsa-digital/evo-shared-components/helpers/colors';
import styled from 'styled-components';

export const RefreshContainer = styled.div`
  position: fixed;
  top: 8px;
  left: 8px;
  z-index: 100; /* Needs to appear above everything */
`;

export const StyledButton = styled(TertiaryButton)`
  background: ${colors.neutral08};
  opacity: 1;
`;

export const StyledIcon = styled(Icon)`
  margin-left: 0.5em;
`;
